import * as lodash from 'lodash';
import { IHandlerAction, IHandlerParams } from 'models/settingsV2.model';
import { ESettingV2URL } from '../../../../../settingsV2Enum';
import { ACTION_IDS } from '../../../../../settingsV2Constant';

export const makeActionHandler = (action: IHandlerAction, params: IHandlerParams) => {
	const { history, selection } = params;
	if (lodash.isNil(selection)) {
		return () => {};
	}
	const userIdList: string[] = selection.map((r: any) => r.id);
	switch (action.id) {
		case ACTION_IDS.BULK_ACTIONS:
			return () => {
				history.push({
					pathname: ESettingV2URL.HANDLE_BULK_PERMISSION_ACTIONS_URL,
					state: {
						userIdList
					}
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
